import { BaseFormPostInputModel } from "../../../../../models/http/InputModel/BaseFormPostInputModel"

type Params = {
  imageFile: File
}

export class MyPageUserImagePostInputModel extends BaseFormPostInputModel {
  constructor(private params: Params) {
    super()
  }

  get file(): File {
    return this.params.imageFile
  }
}
